import { ApplicantNameCell } from './ApplicantNameCell';
import { secondsToHumanTime } from '@/utils/secondsToHumanTime';
import {
  CLOSE_REASONS,
  REQUISITION_TYPE_CONFIG,
} from '@/constants/requisition-constants';
import { StatusTag } from '@/components/shared/requisitions/associate-req/components/RequisitionItem';
import { KImage, KTag, KText } from '@/ui-library/components';
import { Flex, Link } from '@chakra-ui/react';

export const RequisitionIdCell = (row) => {
  const { original } = row;
  const { confidential, status, id, code } = original?.req_code ?? {};
  const reqStatus = status || '';
  const isDraft = reqStatus === 'draft';
  const reqMode = isDraft ? 'draft' : 'view';
  const reqId = id || '';
  return (
    <Flex alignItems="center" gap="8px">
      <Link href={`/requisitions?${reqMode}=${reqId}`} target="_blank">
        <KText
          size="sm-semi-bold"
          color="primary-900"
          _hover={{ textDecoration: 'underline' }}
        >
          {code || '-'}
        </KText>
      </Link>
      {confidential && <KTag value="Confidential" />}
    </Flex>
  );
};

export const RoleNameCell = (row) => {
  const { role_name } = row?.original?.req_code ?? {};
  return (
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {role_name || '-'}
      </KText>
    </Flex>
  );
};

export const RequisitionStatusCell = (row) => {
  const { status = '' } = row?.original?.req_code ?? {};
  return <StatusTag status={status} />;
};

export const AssociatedJobCell = (row) => {
  const { job } = row?.original || {};
  const { id, name } = job?.ats_job || {};

  return (
    <>
      {name && id ? (
        <Link href={`/jobs/${id}`} target="_blank" w="100%">
          <KText
            maxW="100%"
            isTruncated
            enableTooltip={true}
            size="sm-regular"
            _hover={{
              color: 'primary-600',
              textDecor: 'underline',
              cursor: 'pointer',
            }}
          >
            {name}
          </KText>
        </Link>
      ) : (
        <KText size="sm-regular">-</KText>
      )}
    </>
  );
};

export const RequisitionTypeCell = (row) => {
  const { requisition_type = '' } = row?.original?.req_code ?? {};
  const requisitionType =
    REQUISITION_TYPE_CONFIG[requisition_type]?.label || requisition_type;

  return (
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {requisitionType || '-'}
      </KText>
    </Flex>
  );
};

export const CandidateNameCell = (row) => {
  const { filled_application_id = {}, job } = row?.original ?? {};
  const atsApplication = filled_application_id?.ats_application;
  const { id: jobId } = job?.ats_job ?? {};

  return <ApplicantNameCell atsApplication={atsApplication} jobId={jobId} />;
};

export const CloseReasonCell = (row) => {
  const { rejection_reason = '' } = row?.original?.req_code ?? {};
  const reason =
    CLOSE_REASONS?.find((r) => r?.value === rejection_reason)?.label ||
    rejection_reason;
  return <KText size="sm-regular">{reason || '-'}</KText>;
};

export const TimeToFillCell = (row) => {
  const { time_to_fill } = row?.original || {};
  return (
    <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
      {secondsToHumanTime(time_to_fill)}
    </KText>
  );
};

export const CreatedByCell = (row) => {
  const { action_performed_by_id } = row?.original ?? {};

  const userData = action_performed_by_id;
  const userName = userData?.name || '';
  const userAvatar = userData?.avatar || null;

  return (
    <>
      {userName ? (
        <Flex w="100%" alignItems="center" gap="6px">
          <KImage
            name={userName}
            src={userAvatar}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />
          <KText
            maxW="100%"
            enableTooltip={true}
            isTruncated
            size="sm-regular"
            textTransform="capitalize"
          >
            {userName}
          </KText>
        </Flex>
      ) : (
        <KText size="sm-regular">-</KText>
      )}
    </>
  );
};
